<template>
  <v-row>
    <v-col class="px-6">
      <v-card elevation="4" width="100%">
        <v-card-title>
          <span>
            Most Visited Pages
          </span>

          <v-spacer />
          <v-img
            max-height="100"
            max-width="200"
            contain
            class="mx-auto"
            :src="require('../assets/google-analytics-logo.jpg')"
          ></v-img>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="mostVisitedPages"
          :items-per-page="10"
          :loading="loading"
        ></v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { axios } from '../utils'
export default {
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'Page Title',
          align: 'start',
          sortable: true,
          value: 'pageTitle'
        },
        {
          text: 'Views',
          align: 'start',
          sortable: true,
          value: 'pageViews'
        }
      ],
      mostVisitedPages: []
    }
  },
  mounted() {
    axios
      .get(
        `/api/admin/analytics/most-visited-pages?month=${new Date()
          .toISOString()
          .substr(0, 7)}`
      )
      .then(({ data }) => (this.mostVisitedPages = data))
      .then(err => console.log(err))
  }
}
</script>

<style></style>
